import React from 'react'
const Unit =(props)=>{
    return(
        <div className='fx-d-c font-m bgC-white wid-admin-90 hig-auto br-20 shadow-s-noHover pad-5 t b pad-30 b margb-xxs'>
            <div></div>
        </div>
    );

}
export default Unit;